import React from 'react';
import '../App.css';

export default class LoginForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      username: null,
      password: null,
    }
  }

  forgotPassword() {
    this.props.loginApp.setState({showForgotPassword: true, showSignup: false});
  }

  async submitLogin(e) {
    e.preventDefault();
    let username = this.state.username;
    let password = this.state.password;
    let that = this;
    try {
      let fd = new FormData();
      fd.append('username', username);
      fd.append('password', password);
      const d = await fetch('/api/v1/users/login.json', {method: 'POST', body: fd});
      if (d?.status === 401) {
        that.props.loginApp.setState({
          loginFailure: true,
          message: 'Login ou senha incorreta',
        });
        return;
      }
      if (d?.status === 429) {
        alert('Máximo de tentativas excedidas. Por favor, tente novamente mais tarde.');
        return;
      }
      d.json().then(data => {
        if (data.errors) {
          if (err.toString().indexOf('cancelled') !== -1) {
            that.props.loginApp.setState({
              loginFailure: true,
              message: 'Sua conta ainda não foi ativada. Clique no link em sua mensagem de e-mail para completar o registro da conta.',
            });
          } else {
            that.props.loginApp.setState({
              loginFailure: true,
              message: 'Unknown Error: ' + err.toString()
            });
          }
          return;
        }
        that.setState({user: d['user']});
        // that.props.loginApp.setState({
        // loginFailure: true,
        // message: 'Sua conta ainda não foi ativada. Clique no link em sua mensagem de e-mail para completar o registro da conta.',
        if (that.props?.mainApp?.state) {
          // TODO - WTF?
          that.props.mainApp.state['user'] = d['user'];
          window.location = window.location.protocol + '//' + window.location.host;
        } else {
          console.log('Unknown error condition during authentication');
        }
      });
    } catch(e) {
      console.log('Login error: ' + e);
    }
  }

  showSignup() {
    this.props.loginApp.setState({showSignup: true, showForgotPassword: false});
  }

  /* <button className='facebookLoginButton' onClick={this.submitLogin.bind(this)}>
    Sign in with Facebook
  </button> */

  render() {
    // <div className='loginLinks' onClick={this.showSignup.bind(this)}>Create account</div>
    return (
      <div className='logindiv'>
        Sign In <br />
        <form onSubmit={(e) => this.submitLogin(e)}>
          <input className='logInput' placeholder='Username or Email address' type='text' onChange={(e) => this.setState({username: e.target.value})}
                 value={this.state.username || ''} /> <br />
          <input className='logInput' placeholder='Password' type='password' onChange={(e) => this.setState({password: e.target.value})}
                 value={this.state.password || ''} /> <br />
            <button className='loginButton' type='button' onClick={this.submitLogin.bind(this)}>
            Sign In
          </button>
          <center>
            <div className='loginLinks' onClick={(e) => this.showSignup()}>Cadastre-se!</div>
            <div className='loginLinks' onClick={(e) => this.forgotPassword()}>Esqueceu sua senha?</div>
          </center>
        </form>
      </div>
    );
  }
}
